import React, { useContext, useState } from 'react';
import InputRegister from '../../blocks/ui/InputDesign';
import { contactValidator, emailValidator, firstNameValidator, fullNameValidator, lastNameValidator, organisationValidate } from '../../../utils/validator';
// import { createspoc } from '../../services/AdminApi/createspoc';
import { DContext } from '../../../context/Datacontext';

import { useNavigate, useParams } from 'react-router-dom';
import { createSPOC } from '../../services/managerApi/SPOCApis';

export default function SpocCreate() {
    const { BeURL, showAlert, currentUser } = useContext(DContext)

    const { clientId } = useParams()
    const navigate = useNavigate()

    const [spoc, setSpoc] = useState({
        firstName: '',
        lastName: '',
        fullName: '',
        email: '',
        alternateEmail: '',
        contact: '',
        alternateContact: '',
        designation: '',
        location: '',
    })

    const [errors, setErrors] = useState({ spoc: {} })

    const handlespoc = (name, value) => {

        const renderFullName = (spoc) => {
            const first = spoc.firstName?.trim() || "";
            const last = spoc.lastName?.trim() || "";
            return [first, last].filter(Boolean).join(" ");
        };

        if (["firstName", "lastName"].includes(name)) {
            if (/^[A-Za-z. ]*$/.test(value)) {
                setSpoc((prev) => {
                    const updated = { ...prev, [name]: value };
                    return { ...updated, fullName: renderFullName(updated) };
                });
            }
        } else if (["contact", "alternateContact"].includes(name)) {
            if (/^[0-9]*$/.test(value)) {
                setSpoc((prev) => ({ ...prev, [name]: value }));
            }
        }

        else {
            setSpoc((prev) => ({ ...prev, [name]: value }));
        }

        let errmsg = '';
        switch (name) {
            case "firstName":
                errmsg = firstNameValidator(value);
                break;

            case "fullName":
                errmsg = fullNameValidator(value);
                break;

            case "lastName":
                if (value.trim()) errmsg = lastNameValidator(value); // optional
                break;

            case "email":
                errmsg = emailValidator(value);
                break;

            case "alternateEmail":
                if (value.trim()) errmsg = emailValidator(value); // optional
                break;

            case "contact":
                if (value.trim()) errmsg = contactValidator(value); // optional

                break;

            case "alternateContact":
                if (value.trim()) errmsg = contactValidator(value); // optional
                break;
            case 'location':
                if (value.trim() && !/^[A-Za-z]+$/.test(value)) {
                    errmsg = 'Location should contain only letters';
                }
                break
            // case 'designation':
            //     if (value.trim()) errmsg = 'Designation is required';
            //     break
        }

        setErrors((prev) => ({
            ...prev,
            spoc: {
                ...prev.spoc,
                [name]: errmsg,
            },
        }));
    };

    const isFormValid = (errors) => {
        // Check if all error objects are empty
        return (
            Object.values(errors.spoc || {}).every((err) => !err)
        )
    }

    const handleCreate = async () => {


        const payload = {
            'firstName': spoc.firstName,
            'lastName': spoc.lastName,
            'fullName': spoc.fullName,
            'email': spoc.email,
            'alternateEmail': spoc.alternateEmail,
            'contact': spoc.contact,
            'alternateContact': spoc.alternateContact,
            'designation': spoc.designation,
            'location': spoc.location,
            'clientID': clientId,
            'userId': currentUser.id,
            'companyId': currentUser.company.companyId

        }

        await createSPOC(BeURL, showAlert, payload, setSpoc, navigate)
    }

    return (
        <div className="min-h-[70vh] flex items-center justify-center bg-white p-4 mt-5">
            <div className="bg-slate-50 shadow-xl rounded-2xl w-full max-w-5xl p-8">
                <h2 className="text-3xl font-bold mb-8 text-primary-600 text-center">
                    Register New SPOC
                </h2>

                <div className="grid grid-cols-3 gap-4">

                    {[{
                        label: " FirstName", name: "firstName", value: spoc.firstName, error: errors.spoc?.firstName, mandatory: true,
                        required: true
                    },
                    {
                        label: "  LastName", name: "lastName", value: spoc.lastName, error: errors.spoc?.lastName,
                    },
                    {
                        label: "  FullName", name: "fullName", value: spoc.fullName, error: errors.spoc?.fullName, mandatory: true,
                        required: true
                    },
                    {
                        label: " Email", name: "email", value: spoc.email, error: errors.spoc?.email, mandatory: true,
                        required: true
                    },
                    {
                        label: "  AlternateEmail ", name: "alternateEmail", value: spoc.alternateEmail, error: errors.spoc?.alternateEmail,
                    },
                    {
                        label: "  Contact", name: "contact", value: spoc.contact, error: errors.spoc?.contact,

                    },
                    {
                        label: " AlternateContact", name: "alternateContact", value: spoc.alternateContact, error: errors.spoc?.alternateContact,
                    },
                    {
                        label: "  Location ", name: "location", value: spoc.location, error: errors.spoc?.location,

                    },
                    {
                        label: "  Designation", name: "designation", value: spoc.designation, error: errors.spoc?.designation,

                    }].map((field, idx) => (
                        <div key={idx} className="bg-gray-100 p-4 rounded-xl shadow-inner">
                            <InputRegister
                                label={field.label}
                                value={field.value}
                                name={field.name}
                                mandatory={field.mandatory}
                                required={field.required}
                                placeholder={field.label}
                                type="text"
                                className="w-full"
                                error={field.error}
                                onChange={(e) => handlespoc(e.target.name, e.target.value)}
                            />
                        </div>


                    ))}

                </div>
                <div className="md:col-span-2 flex justify-end mt-4">
                    <button
                        type="submit"
                        disabled={!isFormValid(errors)}
                        className={`px-4 py-2 rounded ${isFormValid(errors)
                            ? "bg-secondary-200 text-white hover:bg-secondary-500"
                            : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
                        onClick={handleCreate}
                    >
                        Create spoc
                    </button>
                </div>
            </div>
        </div>
    );
}
